import * as React from 'react';
import { Card } from 'material-ui/Card';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { compose, lifecycle, withHandlers, withProps } from 'recompose';
import { reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { InputField, Input } from '@components/form';
import { withNotifications } from '@components/hoc/withNotifications';
import { withConfiguration } from '@components/hoc/withConfiguration';
import { required, validatePasswordConfirm, validatePasswordWithMinLength } from '@utils/validators';
import { changeRequiredPassword, isLoggedIn } from '@modules/login/_loginActions';
import {
  getPasswordMinLength,
  isPasswordChangeExtensionEnabled,
  isPasswordChangeRequired
} from '@modules/login/_passwordChange';

const enhance = compose<any, any>(
  withRouter,
  withConfiguration({}),
  withNotifications({ changeRequiredPassword }),
  withProps(() => {
    const passwordMinLength = getPasswordMinLength();

    return {
      passwordMinLength,
      passwordPolicyValidator: validatePasswordWithMinLength(passwordMinLength)
    };
  }),
  withHandlers({
    onSubmit: ({ history, changeRequiredPasswordNotify }) => async formData => {
      const response = await changeRequiredPasswordNotify(formData);

      if (response) {
        history.push('/');
      }
    }
  }),
  lifecycle<any, any, any>({
    componentDidMount() {
      const { config, history } = this.props;

      if (!isLoggedIn()) {
        history.push('/login');
        return;
      }

      if (!isPasswordChangeExtensionEnabled(config.extensions) || !isPasswordChangeRequired()) {
        history.push('/');
      }
    }
  }),
  reduxForm({
    form: 'change-password-form',
    validate: validatePasswordConfirm
  })
);

const View: React.SFC<any> = props => (
  <div>
    <form className="login" onSubmit={props.handleSubmit}>
      <Card className="login-card">
        <div className="login-card-inside">
          <Grid fluid={true}>
            <Row>
              <Col xs={12}>
                <h3>Změna hesla</h3>
                <p>
                  Pro pokračování do aplikace si nastavte nové heslo splňující aktuální bezpečnostní pravidla.
                  Musí obsahovat minimálně {props.passwordMinLength} znaků, malé a velké písmeno, číslici a
                  speciální znak.
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <InputField
                  component={Input}
                  name="password"
                  label="Nové heslo"
                  type="password"
                  validate={[required, props.passwordPolicyValidator]}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <InputField
                  component={Input}
                  name="passwordConfirm"
                  label="Nové heslo znovu"
                  type="password"
                  validate={[required, props.passwordPolicyValidator]}
                />
              </Col>
            </Row>
          </Grid>
          <div className="login-buttons">
            <Button className="login-button" type="submit" label="Změnit heslo" primary={true} />
          </div>
        </div>
      </Card>
    </form>
  </div>
);

export const ChangePasswordPage = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/login/ChangePasswordPage.tsx